import Customer from './account/customer';

document.addEventListener('DOMContentLoaded', () => {
    $('.close-button-info-tooltip').on('click', function (e) {
        $('.popover-loyalty-member-tez').hide();
        $('.slider.round').removeClass('loyalty-highlight');
        e.preventDefault();
    });

    $('body').on('click', '.close-button-info-popover', function (e) {
        $('.popover-remember-me').hide();
        e.preventDefault();
    });

    $('body').on('click', '.icon-info-black, .js-rememberme-tooltip-icon', function (e1) {
        if ($(e1.target).closest('.info-rememberme').length > 0 && !$(e1.target).hasClass('close-button-info-tooltip') && !$(e1.target).hasClass('js-close-rememberme-tooltip')) {
            return;
        }
        e1.stopPropagation();
        $('.info-rememberme').removeClass('hide');
        if ($(this).closest('.js-unified-flow-container').length === 0) {
            $('.tooltip-background').removeClass('hide');
        }
        $('body').on('click.closeTooltipEvent', function (e) {
            if ($(e.target).hasClass('close-button-info-tooltip') || $(e.target).hasClass('js-close-rememberme-tooltip') || $(e.target).closest('.info-rememberme').length === 0) {
                $('.info-rememberme').addClass('hide');
                $('body').off('click.closeTooltipEvent');
                $('.tooltip-background').addClass('hide');
            }
        });
    });

    $('.checkbox-label').on('click', function (e) {
        return false;
    });

    if (Foundation.MediaQuery.atLeast('small')) {
        $('body').on('click', '.icon-info-black, .js-rememberme-tooltip-icon', function (e) {
            if ($(this).closest('.js-unified-flow-container').length === 0 && $(e.target).closest('.info-rememberme').length === 0) {
                $('.tooltip-background').removeClass('hide');
            }
        });
    }

    $('body').on('change', '#rememberMe', function (e) {
        if ($('#rememberMe').prop('checked')) {
            $('.popover-remember-me').hide();
        }
    });

    Customer.accountLoginForm();
    Customer.loginAndAssociateOrderWithLoyaltyCustomer();
    Customer.loginAndAssociateOrderWithCustomer();
    Customer.registerAndAssociateOrderForm();
    Customer.prepareLoyaltySubscriptionForm();
    Customer.forgotPassword();
    Customer.accountRegisterForm();
    Customer.toggleVisiblePassword();
    Customer.slickThankYouPage();
    Customer.datePicker();
    Customer.checkPasswordValidation();
    Customer.resendActivationEmail();
    Customer.socialLoginHandler();
});
